module.exports = __webpack_public_path__ + "img/calendar_with_coins.50361996.svg";